import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { X } from 'lucide-react';

interface CreateWidgetModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onWidgetCreated: (widgetType: string) => void;
}

const widgetTypes = [
  'Costs by Utility Type',
  'Charges by Vendor',
  'Costs by Charge Type',
  'Highest Cost Locations',
  'Monthly Cost by Location',
  'Highest Unit Cost Locations',
  'Highest Consumption Locations',
  'Monthly Consumption by Location',
];

export function CreateWidgetModal({ open, onOpenChange, onWidgetCreated }: CreateWidgetModalProps) {
  const [selectedType, setSelectedType] = useState<string>('');

  const handleCreate = () => {
    if (selectedType) {
      onWidgetCreated(selectedType);
      setSelectedType('');
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <div className="flex items-center justify-between">
            <DialogTitle className="text-2xl">Create Widget</DialogTitle>
            <Button
              variant="ghost"
              size="sm"
              className="h-8 w-8 p-0"
              onClick={() => onOpenChange(false)}
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </DialogHeader>

        <div className="space-y-4 mt-4">
          <div className="space-y-2">
            <Label>Widget Type *</Label>
            <Select value={selectedType} onValueChange={setSelectedType}>
              <SelectTrigger>
                <SelectValue placeholder="Select" />
              </SelectTrigger>
              <SelectContent>
                {widgetTypes.map(type => (
                  <SelectItem key={type} value={type}>
                    {type}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="flex items-center justify-end gap-2 pt-4 border-t">
            <Button
              variant="outline"
              onClick={() => {
                setSelectedType('');
                onOpenChange(false);
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleCreate}
              disabled={!selectedType}
            >
              Create Widget
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

